function getAgentFreshUnitsNotInDanger(agentUnit, allAgentUnits, agentUnitsInDanger, hexProperties) {
    const agentFreshUnitsNotInDanger = allAgentUnits.filter((u) => {
        if (!u.isFatigued && !agentUnitsInDanger[u.id]) {
            return true;
        }
        return false;
    });
    agentFreshUnitsNotInDanger.sort((a, b) => {
        const distanceA = hexProperties.getDistance(a.position, agentUnit.position);
        const distanceB = hexProperties.getDistance(b.position, agentUnit.position);
        if (distanceA === 1) {
            return distanceB === 1 ? 0 : 1;
        }
        if (distanceB === 1) {
            return -1;
        }
        return distanceA - distanceB;
    });
    return agentFreshUnitsNotInDanger;
}
export default getAgentFreshUnitsNotInDanger;
